import {ChangeDetectionStrategy, Component, input} from '@angular/core';

@Component({
  selector: 'cs-chart-detail-dialog-header',
  standalone: true,
  imports: [],
  templateUrl: './cs-chart-detail-dialog-header.component.html',
  styleUrl: './cs-chart-detail-dialog-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsChartDetailDialogHeaderComponent {
  readonly icon = input<string | null | undefined>();
  readonly name = input.required<string>();
  readonly percentComplete = input.required<number>();
  readonly currentValueDisplay = input<string>('');
  readonly targetValueDisplay = input<string>('');
  /** Hex color for the progress circle stroke (e.g. from getColorForName(..., 'metric')). */
  readonly progressColor = input<string | null | undefined>();

  readonly circumference = 2 * Math.PI * 36;

  dashOffset(): number {
    const progress = Math.min(this.percentComplete() / 100, 1);
    return this.circumference * (1 - progress);
  }
}
